import RepresentativesSpecialAttribute from '../models/RepresentativesSpecialAttributes'

export const representativesSpecialAttributes: Array<RepresentativesSpecialAttribute> = [
  {
    id: 1,
    value: 'e-Banking - Ειδικός εκπρόσωπος',
    previewInGroupIds: [8],
    previewText: ' ως ειδικός εκπρόσωπος e-Banking',
  },
  {
    id: 2,
    value: 'e-Banking - Upload εγγράφων νομιμοποίησης',
    previewInGroupIds: [9],
    previewText: ' ως ειδικός εκπρόσωπος e-Banking Upload εγγράφων νομιμοποίησης',
  },
  {
    id: 3,
    value: 'v-Banking  - Ειδικός εκπρόσωπος',
    previewInGroupIds: [10],
    previewText: ' ως ειδικός εκπρόσωπος v-Banking',
  },
  {
    id: 4,
    value: 'SAU',
    previewInGroupIds: [8],
    previewText: ' ως SAU',
  },
]
